import { AmplitudeEventProperty, logAmplitudeEvent } from 'chairisher/util/analytics';

/**
 * Log the `location - search` amplitude event for a given query string and screen
 *
 * @param {string} queryText The location being queried for
 * @param {string} screen Name of the screen on which this query is taking place
 */
export default function trackLocationSearchEvent(queryText, screen) {
    if (queryText.length) {
        logAmplitudeEvent('search - location', {
            [AmplitudeEventProperty.QUERY_TEXT]: queryText,
            [AmplitudeEventProperty.SCREEN]: screen,
        });
    }
}
